import { uniqBy, lowerCase } from 'lodash';
export default function generateProficiencies(rawCharacter, classes, background) {
    const startingClass = rawCharacter.classes[0];
    const startingClassData = startingClass && classes.find(({ name }) => name === startingClass.name);
    const fromStartingClass = startingClassData && [
        startingClassData.weaponProficiencies.map(name => ({
            name,
            type: 'weapon'
        })),
        startingClassData.armorProficiencies.map(name => ({
            name,
            type: 'armor'
        }))
    ].flat();
    const fromOtherClasses = rawCharacter.classes.slice(1)
        .map(({ name }) => {
        const myClass = classes.find(({ name: className }) => className === name);
        return myClass ? myClass.multiClassProficiencies.map(name => ({
            name,
            type: 'other'
        })) : [];
    })
        .flat();
    const fromBackground = background && background.toolProficiencies ? [{
            name: background.toolProficiencies,
            type: 'tool'
        }] : [];
    return uniqBy([
        ...(fromStartingClass || []),
        ...fromOtherClasses,
        ...fromBackground
    ], proficiency => lowerCase(proficiency.name));
}
